module.exports = __webpack_public_path__ + "static/media/dd-logo.9c8a5d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/static/dd-logo.png
// module id = 41
// module chunks = 0